import React, { useState, useEffect } from "react";
import axios from "./axios";
import "./row.css";

function Row({ title, fetchUrl, isLargeRow }) {
  const imgUrl = "https://image.tmdb.org/t/p/w500";
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    async function movieFetcher() {
      const req = await axios.get(fetchUrl);
      setMovies(req.data.results);
    }
    movieFetcher();
  }, [fetchUrl]);

  return (
    <div className='row'>
      <h1>{title}</h1>
      <div className='row__posters'>
        {movies.map((movie) => (
          <img
            key={movie.id}
            className={`row__poster ${isLargeRow && "row__posterLarge"}`}
            src={`${imgUrl}${
              isLargeRow ? movie.poster_path : movie.backdrop_path
            }`}
            alt=''
          />
        ))}
      </div>
    </div>
  );
}

export default Row;
